<script>
	import Header from './Header.svelte';
	import { springIn } from "svelte-helpers/spring-transitions";
	import { pop } from 'svelte-spa-router'

	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	const modal = writable(null);

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let result = null;
    let show_close = true;
	let social_link = null;
	let social_msg = null;
	let copied = false;
    let title = '';
    let stats_a = '';
    let stats_b = '';
    let mission = '';
    let join_stmt = '';
    let status = '';
    let n = '';
    let join_n = '';
    let join_prog_n = '';
    let prog_n = '';
    let prog_steps_n = '';
    let prog_miles = '';
    let supp_n = '';
    let chall = null;
    let img = '';
	let timeout_id;
    let has_joined = 0;
    let joined_str = 'Join'

    export let params = {}

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
	}

	let chall_id = params.id
	let mebot_id = getCookie('m_id');

    async function fetchChallenge(chall_id = 0) {

		let res = await fetch('https://api.forever.today/?method=get_challenge', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                chall_id
            })
		})

        let json = await res.json()
        result = json
        //json.data.mebots.forEach((x, i) => console.log(x));

        chall = json.data.chall;
        if (chall.title != '') {
    		title = chall.title;
            social_link = chall.social_link;
    		social_msg = chall.social_msg;
            n = chall.n_desc;
            img = chall.img;
            stats_a = chall.stats_a;
            stats_b = chall.stats_b;
            status = chall.status;
            mission = chall.mission;
            join_n = chall.join_n;
            join_prog_n = chall.join_prog_n;
            prog_n = chall.prog_n;
            prog_steps_n = chall.prog_steps_n;
            prog_miles = chall.prog_miles;
            supp_n = chall.supp_n;
            join_stmt = chall.join_stmt;
            has_joined = chall.has_joined;
            if (has_joined == 1) {
                joined_str = 'Joined'
            }
        }
    }

    fetchChallenge(chall_id)

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn1 = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, SPRING_IN);
		return {
			duration: 50000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {
		//copyError();
		//return;
		copied = true;
		if (copied == true) {
			setTimeout(
				function() {
					copied = false;
					showLinkCopied()
				},
			300
			);
		}
	}

	function copyError() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		let msg = `
		<center>
		<br><br>
		🔗 Challenge link:<br><br>
		<input value="` + social_link + `"></input>
		<br><br><br>`;

		if (social_msg != null) {
			msg = msg + `<br>
			🐦 Share tweet:<br><br>
			<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
			<br><br><br>
			`
		}

		displayMebotMessage(msg, 100000);
	}

	function copyLink() {
		var copyText = document.getElementById("social_link");
		//alert("Copied the text: " + copyText.value);

		copyToClipboard(copyText.value)
			.then(() => copySuccess() )
			.catch(() => copyError() );
	}

	function showLinkCopied() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		let msg = `
		<center>
		<br><br><br>
		Link 🔗 copied to your clipboard.<br><br>

		<br>`;

		if (social_msg != null) {
			msg = msg + `<br>
			🐦 Share tweet or post on Threads:<br><br>
			<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
			<br><br>
			`
		}

		displayMebotMessage(msg, 100000, 'Copy');
	}

	function showMission() {

		displayMebotMessage(`
		<center>
<br>
			` + mission + `
<br><br>
		</center>`, 25000, '♾️');
	}


	function showJoin() {

        if (has_joined == 0) {

		displayMebotMessage(`
		<center>
<br>
			` + join_stmt + `
<br><br>
		</center>`, 25000, 'Join ➡️', onJoinAction);

        }

    }

	async function joinChallenge() {

        if (dash_token == '1') {

            window.location.replace('https://app.mebots.xyz/invite.html?');

        } else {

        joined_str = 'Joined';
        has_joined = 1;

		const res = await fetch(
			"https://api.forever.today/?method=join_challenge",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					chall_id,
				}),
			}
		);

        }
	}

    const onJoinAction = () => {
        joinChallenge();
    };

</script>

<Header
    header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>
<center>
	{#if title != ''}
	<table width=300px border=0 height=240px>
		<tr>
			<td width="50px" valign=top align=center>
				<table border=0 height=240px>
					<tr>
						<td height="44px" align=center valign=middle>
							<span class="text-glow1 mebot-byline" style="font-size: 20px;"  on:click={ () => pop() }>
								✖️ 
							</span>
						</td>
					</tr>
                    <tr>
                        <td height=200> &nbsp; </td>
                    </tr>
				</table>
			</td>
			<td width=240px align=center>
				<div style="user-select: none; width: 220px;" >
                    <span class="text-electric" style="font-size: 22px;">
                        {@html title }
                    </span>

                    <div style="margin-top: 50px; margin-bottom: 0px;">
                        <div class="shadow_bg">
                        {#if img != '' }
                            <img src="{img}" width=180px height=72px alt="Challenge">
                        {/if}
                        </div>
                    </div>
				</div>
                <br>

                {#if stats_a != ''}
                <table border=0 width=220px>
                    <tr>
                        <td align=center class="shadow_bg">
                            <div class="vitals2 text-glow" style="white-space: nowrap;">{@html stats_a }</div>
                        </td>
                        <td align=center class="shadow_bg">
                            <div class="vitals2 text-glow" style="white-space: nowrap;">{@html stats_b }</div>
                        </td>
                    </tr>
                </table>
                {/if}
			</td>
			<td width="100px" valign=top>
				<table border=0 height=245px>
					<tr>

                        <td width=20px height="28px" align=center valign=bottom on:click={ copyLink }>
                            <div class="text-electric" >
                                <input size="22" type="hidden" id="social_link" bind:value={social_link} >
                                <span class="tooltip1" style="font-size: 10px; white-space: nowrap;" class:copy-pulsing={ copied }> <span>&nbsp;🔗&nbsp;</span> </span>
                            </div>
                        </td>
    
                    </tr>
					<tr>
						<td align=center>
						</td>
					</tr>
					<tr>
                        <td></td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

    {#if prog_n != ''}
	<table width=300px border=0>

        <tr>
            <td align=right valign=bottom><div class="progress" style="white-space: nowrap;"> &nbsp; </div></td>
            <td align=center valign=bottom>
                <span class="progress" style="white-space: nowrap;"> { prog_steps_n } </span>
            </td>
        </tr>    

        <tr>
        <td align=right valign=bottom><div class="progress" style="white-space: nowrap;"> 🏃‍♀️ Progress </div></td>
        <td align=center valign=bottom>
            <span class="progress " style="white-space: nowrap;"> { prog_n } </span>
        </td>
        </tr>

        <tr>
            <td align=right valign=bottom><div class="progress" style="white-space: nowrap;"> &nbsp; </div></td>
            <td align=center valign=bottom>
                <span class="progress" style="white-space: nowrap;"> { prog_miles } </span>
            </td>
        </tr>    
<!--
        <tr>
        <td align=right valign=bottom><div class="support_n" style="white-space: nowrap;"> $ Raised </div></td>
        <td align=center valign=bottom>
            <span class="support_n" style="white-space: nowrap;"> { supp_n } </span>
        </td>
        </tr>
-->
        <tr>
            <td align=right valign=bottom><div class="join_n" style="white-space: nowrap;"> { join_n } Joined </div></td>
            <td align=center valign=bottom>
                <span class="join_n" style="white-space: nowrap;"> { join_prog_n } </span>
            </td>
        </tr>

    </table>
    {/if}

    <br><br>
	<table width=300px border=0>
        {#if mission != ''}
        <tr><td colspan="4" align=center>
            <table>
                <tr><td>
                    <button class="tooltip" style="white-space: nowrap;" on:click={ showMission }>&nbsp; Mission &nbsp;</button> 
                </td><td>
<!--                    <button class="tooltip support" style="white-space: nowrap;" >&nbsp; Support &nbsp;</button>
    -->
                </td><td>
                    <button class="tooltip join" class:joined={ (has_joined == 1) } class:join-active={ (has_joined == 0) } style="white-space: nowrap;" on:click={ () => showJoin() }>&nbsp; { joined_str } &nbsp;</button>
                </td></tr>
                <tr><td align=center>
                    <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> &nbsp; </div>
                </td><td align=center>
<!--                    <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> - </div>
    -->
                </td><td align=center>
                    <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> { join_n } </div>
                </td></tr>
            </table>
        </td></tr>
        {/if}
        <br>
        <tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp; 📶 &nbsp;Status </div></td>
			<td align=right class="shadow_bg" width=100px> <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> { status } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>

        {#if n != ''}
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp; 💸 &nbsp;Prize </div></td>
			<td align=right class="shadow_bg" width=100px> <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> <b>$10,000</b> &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg" width=100px> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp; 🚶‍♂️ &nbsp;Participants </div></td>
			<td align=right class="shadow_bg" width=100px> <div class="vitals2 text-glow text-electric" style="white-space: nowrap;"> { n } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
        {/if}
	</table>
	{:else}
    <div class="snake_row">
    </div>
	{/if}

	<div class="small_row">
	</div>

</center>

{#if (dash_token == '1' && title != '') }
<center>
	<br>
	<table cellpadding="2" cellspacing=0>
		<tr><td style="text-align:center">
			<a href="https://apps.apple.com/us/app/forever-steps/id1616422453" target="_new"><img src="https://app.mebots.xyz/img/ios_200.png" style="margin-top: 5px; padding: 4px;" height="35px" alt="iOS"></a>
		</td><td style="text-align:center" valign="top">
			<a href="https://play.google.com/store/apps/details?id=today.forever.steps" target="_new"><img src="https://app.mebots.xyz/img/android_200.png" height="35px" style="margin-top: 5px; padding: 4px;" alt="Android"></a>
		</td></tr>
	</table>
</center>
{/if}

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

.text-electric {
    font-size: 14px;
	text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
		0 0 14px hsla(178, 100%, 63%, 0.98);
	font-family: arial;
	color: hsl(185, 97%, 75%);
}

.support_n {
    font-size: 14px;
	text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
		0 0 14px #fbbb25;
	font-family: arial;
    color: #fba609;
    font-size: 12px;
}

.join_n {
    font-size: 14px;
	text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
		0 0 14px  rgba(208, 133, 203, 0.532);
	font-family: arial;
    color: #b76af9;
    font-size: 12px;
}

.progress {
    font-size: 14px;
	text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
		0 0 14px hsla(178, 100%, 63%, 0.98);
	font-family: arial;
    color: #1bffe8ee;
    font-size: 12px;
}

.shadow_bg {
	background:#7f7f7f;
	background:rgba(0,0,0,0.15);
	border-radius: 6px;
}

.mebot-byline {
	font-size: 10px;
	white-space: nowrap;
}

.vitals2 {
	color: white;
	font-size: 12px;
}

.tooltip {
	margin-top: 0px;
	font-size: 17px;
	border-radius: 6px;
	border: 1px solid rgb(83, 83, 83);
	background-color:  #1bffe839;
	color: #1bffe8ee;
	padding: 3px;
	box-shadow: 0 5px 15px rgba(3, 252, 227, 0.4);
}

.join {
	background-color: #a200ff58;
    color: #ffffff;
	box-shadow: 0 5px 15px rgba(208, 133, 203, 0.532);
}

.joined {
	background-color: #f3deff;
    color: #b76af9;
	box-shadow: 0 5px 15px rgba(208, 133, 203, 0.532);
}

.support {
	background-color: #ffa60052;
    color: #fbbb25;
	box-shadow: 0 5px 15px rgba(208, 178, 133, 0.532);
}

.join-active {

        background: linear-gradient(114deg, #42fff91e, #b76af9, #42e3ff51);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 4s ease infinite;
		-moz-animation: AnimationName 4s ease infinite;
		-o-animation: AnimationName 4s ease infinite;
		animation: AnimationName 4s ease infinite;

		@-webkit-keyframes AnimationName {
			0%{background-position:0% 71%}
			50%{background-position:100% 30%}
			100%{background-position:0% 71%}
		}
}
@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
}
@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
}
@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
}

</style>